// Global request tracker to prevent overlapping requests
const activeRequestTimestamps: Record<string, number> = {};
const MIN_REQUEST_INTERVAL = 5000; // Minimum 5 seconds between identical requests

/**
 * Checks if a request should be throttled based on the time since the last request with the same key
 * @param key - Unique identifier for the request type
 * @returns boolean indicating whether the request should be throttled
 */
export function shouldThrottleRequest(key: string): boolean {
  const now = Date.now();
  const lastRequestTime = activeRequestTimestamps[key] || 0;
  const timeSinceLastRequest = now - lastRequestTime;
  
  if (timeSinceLastRequest < MIN_REQUEST_INTERVAL) {
    console.log(`Throttling request for ${key}, last request was ${timeSinceLastRequest}ms ago`);
    return true;
  }
  
  // Update the timestamp
  activeRequestTimestamps[key] = now;
  return false;
}

/**
 * Waits for the minimum interval if a request is throttled, then continues
 * @param key - Unique identifier for the request type
 * @param lastDataRef - Optional reference to the last known data for this request
 * @returns The last known data or undefined after waiting
 */
export async function handleThrottling(key: string, lastDataRef?: any): Promise<any | undefined> {
  if (shouldThrottleRequest(key)) {
    // Return the last known data if available
    if (lastDataRef) return lastDataRef;
    
    // If no data available, wait for the minimum interval then allow the request
    await new Promise(resolve => setTimeout(resolve, MIN_REQUEST_INTERVAL));
  }
  
  return undefined;
}
